<template>
  <el-container style="height: 100vh">
    <el-aside width="250px">
      <Menu></Menu>
    </el-aside>
    <el-container>
      <el-header>
        <Header></Header>
      </el-header>
      <el-main class="main">
        <router-view></router-view>
      </el-main>
    </el-container>
  </el-container>
</template>
<script>
import Menu from "@/components/Menu.vue";
import Header from "@/components/Header.vue";
export default {
  components: { Menu, Header },
  data() {
    return {};
  },
  methods: {},
  created() { },
};
</script>
<style scoped>
.el-main {
  background-color: #f1f1f1;
  padding: 10px;
}
</style>
